import { connect } from 'react-redux';
import { IRootState } from '../../redux/state';

import Main from './Main';

function mapStateToProps(state: IRootState) {
  const authentication = state.authentication;
  return {
    authentication,
  };
}

export default connect(mapStateToProps)(Main);
